module.exports = __webpack_public_path__ + "static/bg_0731.1106064b.png";